module.exports = __webpack_public_path__ + "img/fondo1.6336768d.jpg";